import React from 'react';
import {
  initMercadoPago,
  CardPayment as CPMercadopago,
} from '@mercadopago/sdk-react';

initMercadoPago(window.AppENV.mercadopagoPK);

const MercadopagoForm = ({ email, amount, onSubmit, onReady, submitLabel }) => {
  const customization = {
    visual: {
      hideFormTitle: true,
      hidePaymentButton: false,
      style: {
        theme: 'default',
        customVariables: {
          formBackgroundColor: 'rgba(0,0,0,0)',
          outlineSecondaryColor: '#FFB500',
          formPadding: '0px',
          inputBackgroundColor: '#fafafa',
          textPrimaryColor: '#666',
          buttonTextColor: '#141C27',
          baseColor: '#FFB500',
          primaryColor: '#FFB500',
        },
      },
      texts: {
        formSubmit: submitLabel || 'Comprar'
      }
    },
    paymentMethods: {
      maxInstallments: 1,
    },
  };
  return (
     <CPMercadopago
      initialization={{
        amount,
        payer: {
          email,
        },
      }}
      onReady={onReady}
      locale='es-AR'
      onSubmit={onSubmit}
      customization={customization}
    />
  )
};

export default React.memo(MercadopagoForm);

